export const usuarios = {
  title: 'User management',
  description: 'Search for users to assign roles or change access.',
  searchPlaceholder: 'Search by name or email...',
  email: 'Email',
  perfis: 'Roles',
  empty: {
    idle: 'Type to search for users.',
    semResultados: 'No users found.',
  },
  acoes: {
    label: 'Actions',
    promover: 'Assign role',
    inativar: 'Deactivate',
    reativar: 'Reactivate',
  },
  promover: {
    title: 'Assign role',
    description: 'Add a role to {{name}}. The operation is additive: existing roles are kept.',
    selecioneLabel: 'Role',
    selecionePlaceholder: 'Select a role',
    confirmar: 'Assign',
    sucesso: 'Role assigned successfully.',
    erroAlvoInexistente: 'User not found.',
    erroRoleInvalido: 'Invalid role.',
  },
  inativar: {
    title: 'Deactivate user',
    description: 'Deactivate {{name}}? Access will be revoked, but history is preserved.',
    sucesso: 'User deactivated.',
  },
  reativar: {
    title: 'Reactivate user',
    description: 'Reactivate {{name}}? Access will be restored with roles preserved.',
    sucesso: 'User reactivated.',
  },
} as const;
